<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>

          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            v-if="dialog.form"
            width="800"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center px-4 py-2 text-right popup-header">
                <div
                  class="fs-16 font_weight_700">
                  Kumpulkan Tugas
                </div>
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.form = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="22"
                  color="#9ca3af">
                  mdi-close
                </v-icon>
              </v-card-title>
  
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 mb-4 mt-2">
                <ValidationObserver 
                  ref="form">
                  <v-form>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12" class="py-0">
                            <ValidationProvider 
                              name="Jawaban" 
                              rules="" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Jawaban

                              <!-- <span class="red--text">*</span> -->
                              </div>
      
                              <v-textarea
                                solo
                                rounded
                                dense
                                rows="3"
      
                                :color="set_color"
                                placeholder="Contoh. xxxxxxxxx"
                                v-model="form.jawaban"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-textarea>
                            </ValidationProvider>

                            <div>
                              <div class="fs-13 mb-1">
                                Lampiran
                              </div> 
                              <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3">
                                <div class="mr-3">
                                  <uploadfolder
                                    v-model="upload.image" >
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-btn
                                        color="#4B4B4B"
                                        elevation="0"
                                        small
                                        :disabled="process.image"
                                        :loading="process.image"
                                        min-height="30"
                                        class="fs-12 white--text text-capitalize d-flex align-center"
                                        style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                        <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                        
                                        <span
                                          class="ml-2 ">
                                          Tambah Gambar
                                        </span>
                                      </v-btn>
                                    </div>
                                  </uploadfolder>
                                </div>
                                <div class="mr-3">
                                  <uploaddoc
                                    v-model="upload.document" >
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-btn
                                        color="primary"
                                        elevation="0"
                                        small
                                        :disabled="process.document"
                                        :loading="process.document"
                                        min-height="30"
                                        class="fs-12 white--text text-capitalize d-flex align-center"
                                        style="border-radius: 6px; font-weight: 600;">
                                        <v-icon size="15">mdi-file-document</v-icon>
                                        
                                        <span
                                          class="ml-2 ">
                                          Tambah File
                                        </span>
                                      </v-btn>
                                    </div>
                                  </uploaddoc>
                                </div>
                              </div>

                              <div class="">
                                <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                  <tr>
                                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      Aksi
                                    </th>
                                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                      Link
                                    </th>
                                  </tr>
                                  <tr v-for="(item, index) in form.lampiran_array" :key="index">
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="form.lampiran_array.splice(index, 1)"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>

                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 100%;" class="black--text">
                                      <a
                                        :href="item.url"
                                        target="_blank"
                                        class="d-flex align-center">
                                        <v-icon size="25" :color="extension_file(item.url) === 'pdf' ? '#b40c1d' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? '#1b58b8' : extension_file(item.url) === 'xls' ? '#097640' : extension_file(item.url) === 'xlsx' ? '#097640' : 'indigo'">{{ extension_file(item.url) === 'pdf' ? 'mdi-file-pdf' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? 'mdi-file-word' : extension_file(item.url) === 'xlsx' ? 'mdi-file-excel' : extension_file(item.url) === 'xls' ? 'mdi-file-excel' : 'mdi-image-area' }}</v-icon>
                                        
                                        <span
                                          class="ml-2">
                                          {{ item.url.split('/')[6] }}
                                        </span>
                                      </a>
                                      <!-- <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :color="extension_file(item.url) === 'pdf' ? '#b40c1d' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? '#1b58b8' : extension_file(item.url) === 'xls' ? '#097640' : extension_file(item.url) === 'xlsx' ? '#097640' : 'indigo'"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">{{ extension_file(item.url) === 'pdf' ? 'mdi-file-pdf' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? 'mdi-file-word' : extension_file(item.url) === 'xlsx' ? 'mdi-file-excel' : extension_file(item.url) === 'xls' ? 'mdi-file-excel' : 'mdi-image-area' }}</v-icon>
                                          </v-btn>
                                        </template>

                                        <span>Lihat</span>
                                      </v-tooltip> -->
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <v-card-text
                                v-if="form.lampiran_array.length === 0"
                                class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                                <div class="text-center">
                                  <div class="mt-3 fs-16">
                                    Belum ada data
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
  
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form || (form.jawaban === '' && form.lampiran_array.length === 0)"
                  width="85"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="dialog.form = false; reset();"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Hapus Data
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
              </v-card-text>
  
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
  
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Hapus
                </v-btn>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.nilai"
            @keydown.esc="dialog.nilai = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Berikan Nilai
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.nilai = false; dialog.fullscreen = false; selected.nilai = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
                <v-card-text 
                class="py-0 mb-4 mt-2">
                <ValidationObserver 
                  ref="form">
                  <v-form>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12" class="py-0">
                            <ValidationProvider 
                              name="Nilai (Dalam Angka)" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Nilai (Dalam Angka)
                              <span class="red--text">*</span>
                              </div>
      
                              <v-currency-field
                                solo
                                rounded
                                dense
                                :allow-negative="false"
      
                                :color="set_color"
                                placeholder="Contoh. 100"
                                v-model="form_nilai.nilai_value"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-currency-field>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="Nilai (Dalam Huruf)" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Nilai (Dalam Huruf)
                              <span class="red--text">*</span>
                              </div>
      
                              <v-autocomplete
                                solo
                                rounded
                                dense
                                :items="[ 'A', 'B', 'C', 'D', 'E' ]"
      
                                :color="set_color"
                                placeholder="Contoh. A"
                                v-model="form_nilai.nilai_abjad"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
  
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  @click="saveNilai()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="85"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="dialog.nilai = false; reset();"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.message"
            @keydown.esc="dialog.message = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Kirim Pesan Ke Wali Murid
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.message = false; dialog.fullscreen = false; selected.message = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
                <v-card-text 
                class="py-0 mb-4 mt-2">
                <ValidationObserver 
                  ref="form">
                  <v-form>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12" class="py-0">
                            <ValidationProvider 
                              name="Pesan" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Pesan
                              <span class="red--text">*</span>
                              </div>
      
                              <v-textarea
                                solo
                                rounded
                                dense
                                :color="set_color"
                                placeholder="Pesan"
                                v-model="form_message.message"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-textarea>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
  
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  :loading="process.form"
                  :disabled="process.form"
                  width="85"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Kirim
                </v-btn>
  
                <v-btn
                  @click="dialog.message = false; reset();"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.detail_jawaban"
            @keydown.esc="dialog.detail_jawaban = false"
            :fullscreen="dialog.fullscreen"
            v-if="dialog.detail_jawaban"
            width="660"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Detail Jawaban
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.detail_jawaban = false; dialog.fullscreen = false; selected.detail_jawaban = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 mb-4 mt-0 px-3">
                <v-row>
                  <v-col cols="12" md="12">
                    <div class="px-2">
                      <table style="border: none; width: 100%; border-collapse: collapse;">
                        <tr>
                          <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 0px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                            Nama Siswa
                          </td>
                          <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                            :
                          </td>
                          <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                            {{ detail.tugas_siswa_kumpul[selected.nilai[0]].siswa_name }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 0px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                            Tanggal Kumpul
                          </td>
                          <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                            :
                          </td>
                          <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                            {{ detail.tugas_siswa_kumpul[selected.nilai[0]].dikumpulkan_datetime | datetime }}
                          </td>
                        </tr>
                      </table>
                    </div>

                    <v-divider 
                      class="mt-2" />

                    <div class="px-2">
                      <div class="mt-2 mb-4 black--text">
                        <div class="fs-13 mb-1">
                          Jawaban : 
                        </div> 
                        <div>
                          {{ detail.tugas_siswa_kumpul[selected.nilai[0]].jawaban }}
                        </div>
                      </div>
  
                      <div style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 0px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text mb-2">
                        Lampiran Jawaban : 
                      </div>
  
                      <div class="px-0">
                        <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                          <tr>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              Link
                            </th>
                          </tr>
                          <tr v-for="(item, index) in detail.tugas_siswa_kumpul[selected.nilai[0]].lampiran_array" :key="index">
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 100%;" class="black--text">
                              <a
                                :href="item.url"
                                target="_blank"
                                class="d-flex align-center">
                                <v-icon size="25" :color="extension_file(item.url) === 'pdf' ? '#b40c1d' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? '#1b58b8' : extension_file(item.url) === 'xls' ? '#097640' : extension_file(item.url) === 'xlsx' ? '#097640' : 'indigo'">{{ extension_file(item.url) === 'pdf' ? 'mdi-file-pdf' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? 'mdi-file-word' : extension_file(item.url) === 'xlsx' ? 'mdi-file-excel' : extension_file(item.url) === 'xls' ? 'mdi-file-excel' : 'mdi-image-area' }}</v-icon>
                                
                                <span
                                  class="ml-2">
                                  {{ item.url.split('/')[6] }}
                                </span>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </div>
  
                      <div class="mt-4 mb-4 black--text">
                        <div class="fs-13 mb-1">
                          Nilai : 
                        </div> 
                        <div>
                          {{ detail.tugas_siswa_kumpul[selected.nilai[0]].nilai === '0' ? '-' : detail.tugas_siswa_kumpul[selected.nilai[0]].nilai }} ( {{ detail.tugas_siswa_kumpul[selected.nilai[0]].nilai_abjad === null ? '-' : detail.tugas_siswa_kumpul[selected.nilai[0]].nilai_abjad }} )
                        </div>
                      </div>
                    </div>

                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  :loading="process.form"
                  :disabled="process.form"
                  width="85"
                  @click="dialog.nilai = true"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Nilai
                </v-btn>
  
                <v-btn
                  @click="dialog.detail_jawaban = false;"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  @click="$router.go(-1)"
                  style="cursor: pointer;"
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-backburger
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>

                      <div class="ml-auto">
                      </div>
    
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card flat v-if="process.load" >
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
                </v-card>
                <v-card 
                  flat
                  v-if="!process.load && Object.keys(detail).length > 0"
                  style="background-color: transparent;">
                  <v-card-text class="pa-0">
                    <v-card flat 
                      style="border-radius: 6px;">
                      <v-card-text>
                        <!-- <v-img
                          :src="form.logo_url !== undefined && form.logo_url !== '' ? form.logo_url : require('@/assets/image/image_default.png')"
                          max-height="150"
                          max-width="150"
                          class="">
                        </v-img>
                        <div class="d-flex pt-3 align-end">
                          <div class="">
                            <div class="font_weight_600 black--text fs-14">
                              {{ form.name }}
                            </div>
                            <div class="black--text fs-13 pt-1" style="font-weight: 600;">
                              {{ form.address }}, {{ form.village_name }}, {{ form.district_name }}, {{ form.city_name }}, {{ form.province_name }}
                            </div>
                          </div>
                          <div class="ml-auto text-right" style="width: 300px;">

                            <v-btn
                              :color="form.akreditasi_status === 'A' ? '#4CAF50' : form.akreditasi_status === 'B' ? '#FFC107' : form.akreditasi_status === 'C' ? '#FF5722' : '#9E9E9E'"
                              class="white--text text-capitalize"
                              elevation="0"
                              @click="openDialog"
                              style="border-radius: 4px;">
                              Akreditasi: {{ form.akreditasi_status }}
                            </v-btn>
                          </div>
                        </div>
                        <v-divider class="mt-3"></v-divider> -->

                        <v-row>
                          <v-col cols="12" md="6" class="">
                            <table style="border: none; width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nama Sekolah
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.school_name }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nama Kelas
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.kelas_name }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Mata Pelajaran
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.mapel_name }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Type Tugas
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.type }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                          <v-col cols="12" md="6" class="">
                            <table style="border: none; width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Diberikan Oleh
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.guru_name }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Diberikan Pada
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.date | date }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Tenggat Waktu
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.deadline_datetime | datetime }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Judul Tugas 
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.title === '' || detail.title === null ? '-' : detail.title }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                        </v-row>

                        <v-divider class="my-3"></v-divider>
                        
                        <div style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                          Deskripsi Tugas
                        </div>
                        <div style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ detail.desc }}
                        </div>
                        <v-divider class="my-3"></v-divider>

                        <div style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text mb-2">
                          Lampiran Tugas
                        </div>

                        <div class="px-2">
                          <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                Link
                              </th>
                            </tr>
                            <tr v-for="(item, index) in detail.lampiran_array" :key="index">
                              <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 100%;" class="black--text">
                                <a
                                  :href="item.url"
                                  target="_blank"
                                  class="d-flex align-center">
                                  <v-icon size="25" :color="extension_file(item.url) === 'pdf' ? '#b40c1d' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? '#1b58b8' : extension_file(item.url) === 'xls' ? '#097640' : extension_file(item.url) === 'xlsx' ? '#097640' : 'indigo'">{{ extension_file(item.url) === 'pdf' ? 'mdi-file-pdf' : extension_file(item.url) === 'doc' || extension_file(item.url) === 'docx' ? 'mdi-file-word' : extension_file(item.url) === 'xlsx' ? 'mdi-file-excel' : extension_file(item.url) === 'xls' ? 'mdi-file-excel' : 'mdi-image-area' }}</v-icon>
                                  
                                  <span
                                    class="ml-2">
                                    {{ item.url.split('/')[6] }}
                                  </span>
                                </a>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div class="fs-13 font_weight_600 mb-2 black--text">
                          Penerima
                        </div>

                        <div  class="mx-1">
                          <table style="border: none; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                Aksi
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                Status
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Tanggal Status
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Nama Siswa
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Wali Muird
                              </th>
                              <!-- <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Nomor Handphone
                              </th> -->
                            </tr>
                            <tr v-for="(penerima, index) in detail.tugas_siswa_penerima" :key="index">
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="dialog.form = true; reset(index)"
                                      v-bind="attrs"
                                      v-on="on"
        
                                      min-width="25"
                                      height="25"
                                      x-small
                                      rounded
                                      color="#3b3f5c"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 8px;">
                                      <v-icon size="13">mdi-rhombus-split</v-icon>
                                    </v-btn>
                                  </template>
        
                                  <span>Dikumpulkan</span>
                                </v-tooltip>

                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="dialog.message = true; form_message = ''"
                                      v-bind="attrs"
                                      v-on="on"
        
                                      min-width="25"
                                      height="25"
                                      x-small
                                      rounded
                                      color="primary"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 8px;">
                                      <v-icon size="13">mdi-email-fast</v-icon>
                                    </v-btn>
                                  </template>
        
                                  <span>Kirim Pesan</span>
                                </v-tooltip>
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ penerima.status }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                {{ penerima.dikumpulkan_datetime === null ? '-' : (penerima.dikumpulkan_datetime | datetime) }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ penerima.siswa_name }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ penerima.wali_name }}
                              </td>
                              <!-- <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_last_education === '' || family.siswa_family_last_education === null ? '-' : family.siswa_family_last_education }}
                              </td> 
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_mobile_phone_number === '' || family.siswa_family_mobile_phone_number === null ? '-' : `+${family.siswa_family_mobile_phone_number}` }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                <span v-if="family.siswa_family_penghasilan !== '' && family.siswa_family_penghasilan !== null">
                                  {{ family.siswa_family_penghasilan | price }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_birth_place }}, {{ family.siswa_family_birth_date | date }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                {{ family.siswa_family_status }}
                              </td> -->
                            </tr>
                          </table>

                          <v-card-text
                            v-if="detail.tugas_siswa_penerima.length === 0"
                            class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                            <div class="text-center">
                              <div class="mt-3 fs-16">
                                Belum ada data
                              </div>
                            </div>
                          </v-card-text>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div class="fs-13 font_weight_600 mb-2 black--text">
                          Dikumpulkan
                        </div>

                        <div  class="mx-1">
                          <table style="border: none; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                Aksi
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                Status
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Tanggal Status
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Nama Siswa
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Wali Muird
                              </th>
                              <!-- <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Nomor Handphone
                              </th> -->
                            </tr>
                            <tr v-for="(penerima, index) in detail.tugas_siswa_kumpul" :key="index">
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="dialog.message = true; form_message = ''"
                                      v-bind="attrs"
                                      v-on="on"
        
                                      min-width="25"
                                      height="25"
                                      x-small
                                      rounded
                                      color="primary"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 8px;">
                                      <v-icon size="13">mdi-email-fast</v-icon>
                                    </v-btn>
                                  </template>
        
                                  <span>Kirim Pesan</span>
                                </v-tooltip>

                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="dialog.detail_jawaban = true; resetNilai(index); selected.nilai = [index]"
                                      v-bind="attrs"
                                      v-on="on"
        
                                      min-width="25"
                                      height="25"
                                      x-small
                                      rounded
                                      color="#09baf7"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 8px;">
                                      <v-icon size="13">mdi-information-outline</v-icon>
                                    </v-btn>
                                  </template>
        
                                  <span>Detail</span>
                                </v-tooltip>
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ penerima.status }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                <!-- {{ penerima.dikumpulkan_datetime === null ? '-' : (penerima.dikumpulkan_datetime | datetime) }} -->
                                  <span v-if="penerima.dikumpulkan_datetime === null">
                                    -
                                  </span> 
                                  <span v-else>
                                    {{ penerima.dikumpulkan_datetime | datetime }}
                                  </span>
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ penerima.siswa_name }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ penerima.wali_name }}
                              </td>
                              <!-- <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_last_education === '' || family.siswa_family_last_education === null ? '-' : family.siswa_family_last_education }}
                              </td> 
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_mobile_phone_number === '' || family.siswa_family_mobile_phone_number === null ? '-' : `+${family.siswa_family_mobile_phone_number}` }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                <span v-if="family.siswa_family_penghasilan !== '' && family.siswa_family_penghasilan !== null">
                                  {{ family.siswa_family_penghasilan | price }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_birth_place }}, {{ family.siswa_family_birth_date | date }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                {{ family.siswa_family_status }}
                              </td> -->
                            </tr>
                          </table>

                          <v-card-text
                            v-if="detail.tugas_siswa_kumpul.length === 0"
                            class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                            <div class="text-center">
                              <div class="mt-3 fs-16">
                                Belum ada data
                              </div>
                            </div>
                          </v-card-text>
                        </div>
                      </v-card-text>
                    </v-card>

                    <div v-if="message.error.length > 0"
                      class="text-left mt-0">
                      <div
                        class="error--text d-flex align-start">
                        <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pa-5">
                    <v-spacer/>
  
                    <v-btn
                      to="/manajemen-akademik/tugas-penilaian/daftar-tugas"
                      :disabled="process.form"
                      width="85"
                      outlined
                      elevation="0"
                      color="red"
                      style="border-radius: 6px;"
                      class="fs-13 font-weight-bold text-capitalize white--text">
                      Kembali
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          filter: {
            school_id: '',
          },
          dialog: {
            form: false,
            nilai: false,
            snackbar: false,
            message: false,
            detail_jawaban: false
          },
          step_index: 1,
          detail: {},
          upload: {
            image: '',
            document: null
          },
          form_message: {
            id: '',
            message: ''
          },
          selected: {
            delete: [],
            nilai: [],
            message: []
          },
          form: {
            id: '',
            jawaban: '',
            tugas_id: '',
            school_id: '',
            siswa_id: '',
            lampiran_array: []
          },

          form_nilai: {
            id: '',
            tugas_id: '',
            school_id: '',
            siswa_id: '',
            nilai_value: '',
            nilai_abjad: ''
          },
          province: [],
          city: [],
          subdistrict: [],
          school: [],
          village: [],
          kurikulum: [],
  
          process: {
            load: true,
            image: false,
            form: false,
            document: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        uploadfile: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document_pdf.vue'),
        uploaddoc: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.lampiran_array.push({
                  url: this.upload.image.fileuri,
                  title: ''
                })

                this.upload.image = ''
                this.process.image = false
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.document': {
          handler: function () {
            if (this.upload.document) {
              // this.f.rab_file_object.type = 'file'
              this.message.error = ''
              this.process.document = this.upload.document.process
              
              if (!this.process.document) {
                this.form.lampiran_array.push({
                  url: this.upload.document.fileuri,
                  title: ''
                })

                this.upload.document = null
                this.process.document = false

                // this.f.rab_file_object.url = this.upload.document.fileuri
              }
            }
          },
          deep: true
        },
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        token () {
          return this.$store.state.token
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail() {
            this.process.load = true
           let params = {
            id: this.$route.params.id,
            school_id: this.$route.params.school_id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/tugas/detail' : 'tugas/detail'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              // this.kurikulum = res.results.data
              this.detail = res.results.data

             this.detail.tugas_siswa_kumpul.forEach((item, index) => {
                item.lampiran_array = item.lampiran_array === null ? [] : JSON.parse(item.lampiran_array)
              })
  
              this.process.load = false
            }
          })
        },
        extension_file (file) {
          let ext = file.split('.').pop()
          return ext
        },
        reset(index) {
          if (this.$refs.form) this.$refs.form.reset()
          this.form.jawaban = this.detail.tugas_siswa_penerima[index].jawaban === null ? '' : this.detail.tugas_siswa_penerima[index].jawaban
          this.form.tugas_id = this.$route.params.id
          this.form.school_id = this.$route.params.school_id
          this.form.siswa_id = this.detail.tugas_siswa_penerima[index].siswa_id
          this.form.lampiran_array = this.detail.tugas_siswa_penerima[index].lampiran_array === null ? [] : this.detail.tugas_siswa_penerima[index].lampiran_array

          this.process.form = false
  
          this.message.error = ''
        },
        resetNilai(index) {
          if (this.$refs.form) this.$refs.form.reset()
          this.form_nilai.id = this.detail.tugas_siswa_kumpul[index].id
          this.form_nilai.tugas_id = this.$route.params.id
          this.form_nilai.school_id = this.$route.params.school_id
          this.form_nilai.siswa_id = this.detail.tugas_siswa_kumpul[index].siswa_id
          this.form_nilai.nilai_value = this.detail.tugas_siswa_kumpul[index].nilai_value === null ? '' : this.detail.tugas_siswa_kumpul[index].nilai_value
          this.form_nilai.nilai_abjad = this.detail.tugas_siswa_kumpul[index].nilai_abjad === null ? '' : this.detail.tugas_siswa_kumpul[index].nilai_abjad

          this.process.form = false
  
          this.message.error = ''
        },
        async saveNilai () {
          this.message.error = ''

          const isValid = await this.$refs.form.validate()

          if (isValid) {
            this.process.form = true

            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/tugas/nilai_tugas' : 'tugas/nilai_tugas'

            // SAVE TO REST API
            await post(url, {
              data: this.form_nilai
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false

              if (res.status === 200) {
                this.dialog.nilai = false

                this.dialog.snackbar = true
                this.message.success = res.message

                this.dialog.fullscreen = false

                this.fetchDetail()

              } else {
                this.message.error = res.message
              }
            })

          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
        async save () {
          this.message.error = ''

          const isValid = await this.$refs.form.validate()

          if (isValid) {
            this.process.form = true

            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/tugas/kumpulkan' : 'tugas/kumpulkan'

            // SAVE TO REST API
            this.form.deadline_datetime = `${this.form.date_deadline} ${this.form.time_deadline}:00`
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false

              if (res.status === 200) {
                this.dialog.form = false

                this.dialog.snackbar = true
                this.message.success = res.message

                this.dialog.fullscreen = false

                this.fetchDetail()

              } else {
                this.message.error = res.message
              }
            })

          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
      },
      created () {
      }
    }
  </script>